import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { API_ENDPOINTS } from './config/apiConfig';
import { toast } from 'react-toastify';
import './SettingsScreen.css';
import { plans, Plan } from './config/plansConfig'; // <-- IMPORTAR DESDE EL NUEVO ARCHIV
import PlanCard, { Plan as PlanCardType } from './PlanCard'; // Asegúrate de importar PlanCard
import './PlanCard.css';   // Y sus estilos

interface SettingsScreenProps {
  onBackToChat: () => void;
}

type SettingsView = 'account' | 'users' | 'plan' | 'contact';

// Definimos los planes como una constante fuera del componente

// Ahora usamos este tipo para nuestro array de planes

const SettingsScreen: React.FC<SettingsScreenProps> = ({ onBackToChat }) => {
  const { authData } = useAuth();
  const [activeView, setActiveView] = useState<SettingsView>('plan'); // Inicia en 'plan' para probar

  // --- Estados para el formulario de contacto ---
  const [contactEmail, setContactEmail] = useState(authData.username || '');
  const [contactMessage, setContactMessage] = useState('');
  const [isSending, setIsSending] = useState(false);

  // --- NUEVO ESTADO PARA EL PAGO ---
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);

  // --- FUNCIÓN DE CONTACTO ---
  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!contactMessage.trim()) {
      toast.warn('Por favor, escribe un mensaje.');
      return;
    }
    setIsSending(true);
    try {
      const token = authData.token;
      if (!token) throw new Error("No estás autenticado.");
      
      const requestBody = {
        to: contactEmail,
        subject: 'CONTACTANOS', // Asumiendo que el 'from' se maneja en el backend
        body: contactMessage,
      };

      // Asumiendo que tienes un endpoint para email en tu apiConfig
      const response = await fetch(API_ENDPOINTS.emailResponse, { 
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || 'No se pudo enviar el mensaje.');
      }
      
      toast.success('¡Mensaje enviado con éxito!');
      setContactMessage('');
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setIsSending(false);
    }
  };

  // --- NUEVA FUNCIÓN PARA MANEJAR EL PAGO ---
  const handleSelectPlan = async (plan: PlanCardType) => {
    setIsProcessingPayment(true);
    //const paymentToastId = toast.loading("Iniciando proceso de pago...");

    try {
      const token = authData.token;
      if (!token || !authData.username) throw new Error("Usuario no autenticado.");
      toast.error("Error al procesar el pago: " + ("No está implementado, por el momento solo aceptamos 'Depósitos en Cuenta'"));
    } catch (error: any) {
      toast.error("Error al procesar el pago: " + ("Ocurrió un error inesperado."));
      //toast.update(paymentToastId, { render: error.message || "Ocurrió un error", type: 'error', isLoading: false, autoClose: 5000 });
    } finally {
      setIsProcessingPayment(false);
    }
  };


  const renderContent = () => {
    switch (activeView) {
      case 'account':
        return (
          <div>
            <h2>Tu Cuenta</h2>
            <p><strong>Nombre de Usuario:</strong> {authData.username}</p>
            <p><strong>Rol:</strong> {authData.role}</p>
          </div>
        );
      case 'users':
        return (
          <div>
            <h2>Usuarios</h2>
            <p>Funcionalidad de gestión de usuarios no implementada.</p>
          </div>
        );
      case 'plan':
        return (
          <div>
            <h2>Tu Plan</h2>
            <p>
                <strong>Plan Actual:</strong> {authData.daysRemaining !== null && authData.daysRemaining > 0 ? 'Plan Activo' : 'Plan Gratuito'}
                {authData.daysRemaining !== null && authData.daysRemaining > 0 && ` (vence en ${authData.daysRemaining} días)`}
            </p>
            {authData.daysRemaining === 0 && (
                <p className="warning-text">
                    Estás en modo del Plan Gratuito, tienes permitido 4 consultas diarias. Esto puede modificarse en cualquier momento sin previo aviso.
                </p>
            )}
            <p >
                <strong>Planes:</strong>
                <ol>
                  <li><strong>Free:</strong> Limite de consultas 30 x mes, no requiere pago. esto puede variar en cualquier momento</li>
                  <li><strong>Freemium:</strong> Limite de consltas 60 x mes. exclusivo para clientes suscritos x 3 meses</li>
                  <li><strong>Premium:</strong> limite de consultas 200 x mes.</li>
                </ol>
            </p>
            <h3 className="plans-subtitle">Elige el plan que mejor se adapte a ti:</h3>
            <p>
             <h2 className="fuente-personalizada">
              <h1>DEPOSITAR A NOMBRE DE ALGORITMO JURIDICO SAC.</h1>
              <h2>N° RUC: 206114141035</h2>
              <strong>CUENTAS DE BANCOS</strong>
                <ol>
                  <li><strong>BCP</strong> N° Cuenta: 1947205728029   CCI. 00219400720572802998</li>
                  <li><strong>BVVA</strong> N° Cuenta: 00110261 0200480473</li>
                  <li><strong>INTERBANK</strong> N° Cuenta: 4393007192029</li>
                  <li><strong>BANCO DE LA NACION</strong> N° Cuenta: 0058546291</li>
                </ol>
                </h2>
            </p>
            <div className="plans-grid">
              {plans.map(plan => (
                <PlanCard 
                  key={plan.id} 
                  plan={plan} 
                  isProcessing={isProcessingPayment} 
                  onSelectPlan={handleSelectPlan}
                />
              ))}
            </div>
          </div>
        );
      case 'contact':
        return (
          <div>
            <h2>Contáctanos</h2>
            <form onSubmit={handleContactSubmit}>
              <div className="input-group">
                <label htmlFor="contact-email">Tu correo electrónico</label>
                <input
                  type="email"
                  id="contact-email"
                  placeholder="tucorreo@dominio.com"
                  // defaultValue={contactEmail}
                  onChange={(e) => setContactEmail(e.target.value)}
                  required
                />
              </div>
              <div className="input-group">
                <label htmlFor="contact-message">¿Cómo podemos ayudarte, o deja tu opinion o sugerencia?</label>
                <textarea
                  id="contact-message"
                  rows={6}
                  value={contactMessage}
                  onChange={(e) => setContactMessage(e.target.value)}
                  placeholder="Describe tu consulta o problema..."
                  required
                />
              </div>
              
              <button type="submit" className="action-button" disabled={isSending}>
                {isSending ? 'Enviando...' : 'Enviar Mensaje'}
              </button>
            </form>
            <div className="whatsapp-contact">
              <p>
                Si lo prefieres, puedes contactarnos directamente por{' '}
                <a href="https://wa.me/51989977620" target="_blank" rel="noopener noreferrer">
                  WhatsApp
                </a>.
              </p>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="settings-container">
      <div className="settings-sidebar">
        <button className="back-button" onClick={onBackToChat}>
          ← Volver al Chat
        </button>
        <ul>
          <li className={activeView === 'account' ? 'active' : ''} onClick={() => setActiveView('account')}>Tu Cuenta</li>
          <li className={activeView === 'users' ? 'active' : ''} onClick={() => setActiveView('users')}>Usuarios</li>
          <li className={activeView === 'plan' ? 'active' : ''} onClick={() => setActiveView('plan')}>Tu Plan</li>
          <li className={activeView === 'contact' ? 'active' : ''} onClick={() => setActiveView('contact')}>Contáctanos</li>
        </ul>
      </div>
      <div className="settings-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default SettingsScreen;